import {deserialize, deserializeAs} from 'libs/cerialize';

export class GridAverageCellValueModel {
    @deserialize
    Value: string;

    @deserialize
    IsWrapped: boolean;
}